/* eslint-disable array-callback-return */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import React, { Component } from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { convertPhoneNumber } from 'modules/authorizations/authorizationEditCreate/utils';

import { detectIE } from '../../../utilities/browserUtils';
import {
  getBusCodes,
  getClientSpecificFields,
  getExceptionsByAuthorizationId,
  getReports,
  getSearchCommentResults,
  getSimilarTransfereeSummaries,
  getSubmittedAuthorization,
  getTimelineItems,
  setActiveTransfereeTab,
  setBaseMoveInfo,
  getTransfereeById,
  getSimilarTransferees,
  getAllEnumerations
} from '../transferees.actions';
import { getClientInformation } from '../../authorizations/authorizations.actions';
import { getLocaleDateString } from '../../../utilities/dateFormatter';
import { setBackButtonPath, setPageTitle } from '../../layout/layout.actions';
import { trackRecentItem } from '../../../utilities/trackRecents';
import DocumentsNotes from './documentsNotes.component';
import ExpensesView from './expenses.container';
import LogoSpinner from '../../../common/logoSpinner.component';
import ReadOnlyText from '../../../common/readOnlyText.component';
import ServicesCards from './servicesCards.component';
import TimelineList from './timelineList.component';
import { Box, Button, IconButton, MenuItem, TextField } from '@material-ui/core';
import { getSelectedClientInformation } from 'utilities/authUtils';

import { isSamsungClient } from '../../../utilities/authUtils';

const TabContainer = (props) => {
  return (
    <Typography component="div" style={{ padding: 24 }}>
      {props.children}
    </Typography>
  );
};

TabContainer.propTypes = {

};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginBottom: '2rem',
  },
  errorText: {
    color: 'red',
    fontSize: '1.25rem',
    display: 'inline',
    marginLeft: '0.25rem',
    verticalAlign: 'middle',
  },
  errorIcon: {
    color: 'red',
    fontSize: '1.25rem',
    verticalAlign: 'middle',
  },
  headerBar: {
    width: '100%',
    height: '100%',
    backgroundColor: '#43AAA2',
    lineHeight: '4rem',
    textAlign: 'center',
  },
  headerBarContent: {
    float: 'right',
    display: 'inline-block',
    lineHeight: '4rem',
    marginTop: '1rem',
  },
  coverImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  coverImageContainer: {
    height: '4rem',
    position: 'relative',
  },
  avatar: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    width: 100,
    height: 100,
    // border: '0.4rem solid white'
    margin: 5,
  },
  transfereeName: {
    position: 'absolute',
    left: '130px',
  },
  headerBarText: {
    // position: 'absolute'
  },
  transfereeNameMobile: {
    margin: '1rem',
  },
  employeeInfoBar: {
    margin: '60px 10px 10px 10px',
    // [theme.breakpoints.down('sm')]: {
    //   marginTop: '10px'
    // }
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 500,
  },
});

class SubmittedAuthDetails extends Component {
  constructor(props) {
    super(props);
     
    this.state = {
      isLoadingAuth: false,
      similarTransferees: null,
      isPtCodeProcessActive: false,
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
  }

  async componentDidMount() {
    if (!this.props.fileId) {
      this.props.setPageTitle('My Transferees');
      this.props.setBackButtonPath('/transferees');
    }
    const selectedAuthId = this.props.authorizationID ? this.props.authorizationID : this.props.fileId ? this.props.fileId : decodeURIComponent(this.props.match.params.id);

    const {
      submittedAuthDetail,
      userInformation,
    } = this.props;

    const submittedAuthResp = await this.props.getTransfereeById(selectedAuthId);

    const selectedClient = getSelectedClientInformation();
    const selectedClientId = selectedClient && selectedClient.id ? parseInt(selectedClient.id, 10) : null;
    if (!Number.isNaN(selectedClientId) && selectedClientId !== null) {
      const clientInfoResp = await this.props.getClientInformation(selectedClientId);
      const isPtCodeProcessActive = !!(
        clientInfoResp &&
        clientInfoResp.response &&
        clientInfoResp.response.clientDetails &&
        clientInfoResp.response.clientDetails.isPtCodeProcessActive
      );
      this.setState({ isPtCodeProcessActive });
    }

    await this.props.getAllEnumerations();
    await this.props.getExceptionsByAuthorizationId(selectedAuthId);
    await this.props.getSearchCommentResults(selectedAuthId);
    await this.props.getClientSpecificFields({ AuthorizationID: selectedAuthId });
    await this.props.getBusCodes();
    await this.props.getTimelineItems(selectedAuthId);
    await this.props.getReports(selectedAuthId);
    if (submittedAuthResp.response) {
      const similarTransfereesResp = await this.props.getSimilarTransferees(
        getSelectedClientInformation().id,
        submittedAuthResp.response.transfereeInfo.primaryEmailAddress,
        submittedAuthResp.response.transfereeInfo.primaryPhoneNumber,
      )
      if (similarTransfereesResp.response) this.setState({similarTransferees: similarTransfereesResp.response});
    }
    

    if (submittedAuthDetail && !this.state.isLoadingAuth) {
      const name = `${submittedAuthDetail.transfereeInfo.firstName  } ${  submittedAuthDetail.transfereeInfo.lastName}`;
      const UserName = userInformation.UserName;
      trackRecentItem(this.props.location.pathname, name, 'submittedAuthDetail', UserName);
    }
  }

  handleTabChange = (event, value) => {
    this.props.setActiveTransfereeTab(value);
  };


  
  exportCSV() {
    const { reports, submittedAuthDetail } = this.props;
    const vendorExpenses = submittedAuthDetail ? submittedAuthDetail.ExpenseDetails : [];

    const headers = ['Expense Source', 'Report ID', 'Submitted Currency', 'Submitted Amount',
      'Category', 'Submitted Date', 'Description', 'Status', 'Approved Amount', 'Denied Amount',
      'Paid Amount', 'Paid Currency', 'Paid Amount USD', 'Paid by TRC/Payroll', 'Paid Date', 'Denied Reason',
      'Vendor Name'];

    const allLineItems = [headers];
    const paidTotals = {};

    (reports || []).forEach((r) => {
      (r.ReportLines || []).forEach((rl) => {
        const lineDate = rl.LineDate ? new Date(rl.LineDate).toLocaleDateString() : '';
        const paidByTrcPayroll = rl.IsTrackingExpense && rl.IsTrackingExpense === 'TRUE' ? 'Payroll' : 'TRC';
        const apPostedDate = rl.APPostedDate && paidByTrcPayroll === 'TRC' ? new Date(rl.APPostedDate).toLocaleDateString() : '';
        allLineItems.push(['Employee', rl.ReportID, rl.ReceiptCurrencyCode, '$' + rl.ReceiptAmount,
          rl.ExpenseCodeDescription, lineDate, (rl.LineDescription || '').replace(/,/g, ''), rl.LineStatus,
          '$' + rl.ApprovedAmount, '$' + rl.DeniedAmount, '$' + rl.PaidAmount,
          rl.PaidCurrencyCode, '$' + rl.PaidAmountUSD, paidByTrcPayroll, apPostedDate, rl.Reason, '']);
        if (rl.PaidCurrencyCode) {
          paidTotals[rl.PaidCurrencyCode] = (paidTotals[rl.PaidCurrencyCode] || 0) + (Number(rl.PaidAmount) || 0);
        }
      });
    });

    (vendorExpenses || []).forEach((ve) => {
      const expDate = ve.ExpDate ? new Date(ve.ExpDate).toLocaleDateString() : '';
      allLineItems.push(['Vendor', '', '', '',
        ve.ReportCategory, expDate, (ve.ExpDesc || '').replace(/,/g, ''), '', '', '', '$' + (ve.PayAmount || 0),
        ve.PayInCurrencyCode, '', '', '', '',
        ve.VendorName || '']);
      if (ve.PayInCurrencyCode) {
        paidTotals[ve.PayInCurrencyCode] = (paidTotals[ve.PayInCurrencyCode] || 0) + (Number(ve.PayAmount) || 0);
      }
    });

    Object.keys(paidTotals).forEach((currencyCode) => {
      allLineItems.push(['', '', '', '', '', '', '', '', '', '', `Total: $${paidTotals[currencyCode].toFixed(2)}`, currencyCode]);
    });

    const csvContent = 'data:text/csv;charset=utf-8,' + allLineItems.map((e) => e.join(',')).join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `TRC Expense Export ${new Date().toLocaleDateString()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const { activeTransfereeTab, classes, submittedAuthDetail, allEnums, clientFields, isLoadingAuth, busCodes, timelineItems, reports, clientDivisions, clientInfo } = this.props;
    const isIE = detectIE();

    if (isLoadingAuth) {
      return (
        <div style={{ margin: '2rem' }}>
          <LogoSpinner />
        </div>
      );
    }

    if (!isLoadingAuth && !submittedAuthDetail) {
      return (
        <div className={classes.root}>
          <Paper>
            <div style={{ padding: '1rem' }}>
              <h3>Transferee Details Error</h3>
              <div>
                <CloseIcon className={classes.errorIcon} />
                <div className={classes.errorText}>There was a problem retrieving transferee details. Please check your connection and try again.</div>
              </div>
            </div>
          </Paper>
        </div>
      );
    }

    const {
      transfereeInfo,
      familyMembers,
      services,
      customFieldValues,
      ptCodeHistories,
      tempPTCodeHistories,
      TempPTCodeHistories,
      homesaleSummary,
      globalSummary,
      tempLivingSummary,
      hhgSummary,
      comments,
      expenses,
    } = submittedAuthDetail;

    const normalizedPTCodeHistories =
      (Array.isArray(ptCodeHistories) && ptCodeHistories) ||
      (Array.isArray(tempPTCodeHistories) && tempPTCodeHistories) ||
      (Array.isArray(TempPTCodeHistories) && TempPTCodeHistories) ||
      [];

    const isPtCodeProcessActive = this.state.isPtCodeProcessActive;

    // Normalize comments from { info, attachments } and keep document visibility tied to client-viewable comments.
    const safeComments = Array.isArray(comments) ? comments : [];
    const commentsInfo = safeComments.map((comment) => {
      const info = comment.info || {};
      return {
        ...info,
        hasAttachment: Array.isArray(comment.attachments) ? comment.attachments.length : 0,
      };
    });

    const documents = safeComments
      .filter((comment) => comment.info && comment.info.isClientViewable === true)
      .flatMap((comment) => {
        const attachments = Array.isArray(comment.attachments) ? comment.attachments : [];
        return attachments.map((attachment) => ({
          ...attachment,
          commentId: attachment.commentId ?? comment.info.commentId,
          authorizationCommentId: comment.info.authorizationCommentId,
        }));
      });

    // calculate total days and days left for progress indicator
    let totalDays, daysLeft;
    if (submittedAuthDetail && submittedAuthDetail.transfereeInfo && submittedAuthDetail.transfereeInfo.estimatedMoveDate && submittedAuthDetail.transfereeInfo.initiationDate) {
      const initiationDate = new moment(submittedAuthDetail.transfereeInfo.initiationDate).utc().startOf('day');
      const estMoveDate = new moment(submittedAuthDetail.transfereeInfo.estimatedMoveDate).utc().startOf('day');

      totalDays = estMoveDate.diff(initiationDate, 'days');

      const today = new moment().utc().startOf('day');

      daysLeft = estMoveDate.diff(today, 'days');
      if (daysLeft <= 0) daysLeft = 0;
    }

    const vendorExpenses = [];
    const exceptions = [];

    commentsInfo.map((comment) => {
      if (comment.exceptionTypeId !== null) {
        exceptions.push(comment);
      }
    });

    expenses.map((expense) => {
      vendorExpenses.push(Object.assign({}, expense, { Type: 'Vendor' }));
      return '';
    });

    var numFamilyMembers = 0;
    if (familyMembers) {
      familyMembers.map((f) => { if (f.FamilyMember !== 'Pet') { numFamilyMembers = numFamilyMembers + 1; } })
    }

    return (
      <div>
        {this.state.similarTransferees && this.state.similarTransferees.length > 0 
       // && !userHasPermission('feature:disableConnectedTransfereesDropdown', clientDivisions) 
        && (
          <Box sx={{padding: '0px'}}>
            <TextField
              id={'authSelection'}
              select
              label={'Connected Transferees'}
              className={classes.textField}
              value={decodeURIComponent(this.props.match.params.id)}
              onChange={(e) => this.props.history.push(`/transferees/${e.target.value}`)}
              margin="normal"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              disabled={false}
            >
              {this.state.similarTransferees.map((auth, i) => {

                let formattedStartDate = null;
                let moveInfo = auth.programType;
                if (auth.newJobStartDate) {
                  const startDate = new moment(auth.newJobStartDate);
                  formattedStartDate = startDate.isValid() ? startDate.format('M/D/YYYY'): null;
                }
                
                //Foreign locations are saved differently than domestic so check to see what we should be using and displaying
                //States aren't set for foreign locations so if it's not set, use the country instead
                let oldState = auth.departureState ? auth.departureState : auth.departureCountry ? auth.departureCountry : '[Unknown]'; 
                let newState = auth.destinationState ? auth.destinationState : auth.destinationCountry ? auth.destinationCountry : '[Unknown]'; 
                
                //city is always set for domestic and foreign locations
                let oldCity = auth.departureCity ? auth.departureCity : '[Unknown]'; 
                let newCity = auth.destinationCity ? auth.destinationCity : '[Unknown]'; 
              
                let oldLocation = `${oldCity}, ${oldState}`;
                let newLocation = `${newCity}, ${newState}`; 

                return <MenuItem key={i} value={auth.fileId}>{`${auth.fileNumber} - ${moveInfo} - ${oldLocation} to ${newLocation}${formattedStartDate ? ` - ${formattedStartDate}` : ''}`}</MenuItem>;
              })}
            </TextField>
          </Box>
        )}
        {
        //!userHasPermission('feature:disableMyTransfereesNewMoveButton', clientDivisions) && 
        (
          <div className={classes.coverImageContainer}>
            <div className={classes.headerBar}>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <span className={classes.headerBarContent}>
                  <div className={classes.transfereeName}>
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography style={{ fontSize: '1.5rem', color: 'white' }}>
                        {`${transfereeInfo.firstName  } ${  transfereeInfo.lastName  }${transfereeInfo.nickName ? ` (${transfereeInfo.nickName})` : ''} - ${transfereeInfo.authorizationId}`}
                      </Typography>
                      {isSamsungClient() && 
                    <Box style={{ marginLeft: '1rem' }}>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={this.exportCSV}
                      >
                        <FontAwesomeIcon
                          icon={['fas', 'money-bill-alt']}
                        />
                      </IconButton>
                    </Box>
                  }
                </Box>
              </div>
                  <span>
                    {transfereeInfo.vip && <div style={{ float: 'left', marginRight: '1rem' }}><Typography style={{ color: 'white', fontSize: '1.5rem' }}>VIP<FontAwesomeIcon icon="check" style={{ marginLeft: '0.25rem' }} /></Typography></div>}
                    {/* <div style={{ float: 'right', marginRight: '1rem' }}><Typography style={{ color: 'white', fontSize: '1.5rem' }}><HeartIcon style={{ marginLeft: '0.25rem' }} /></Typography></div> */}
                  </span>
                </span>
                <Box sx={{ marginRight: '10px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={false}
                    className={classes.saveButton}
                    onClick={() => {
                      const payload = {
                        fileId: this.props.match.params.id,
                        firstName: transfereeInfo.firstName,
                        lastName: transfereeInfo.lastName,
                        spouseFirstName: transfereeInfo.spouseFirstName,
                        spouseLastName: transfereeInfo.spouseLastName,
                        nickName: transfereeInfo.nickName,
                        departureAddressLine1: transfereeInfo.departureAddressLine1,
                        departureAddressLine2: transfereeInfo.departureAddressLine2,
                        departureState: transfereeInfo.departureState,
                        departureCity: transfereeInfo.departureCity,
                        departureZip: transfereeInfo.departureZip,
                        departureCountry: transfereeInfo.departureCountry,
                        primaryPhoneNumber: transfereeInfo.primaryPhoneNumber,
                        primaryEmailAddress: transfereeInfo.primaryEmailAddress,
                        spouseEmail: transfereeInfo.spouseEmail,
                        fileNumber: transfereeInfo.fileNumber,
                        clientRecordId: transfereeInfo.clientRecordId,
                        destinationStateId: transfereeInfo.destinationStateId,
                        destinationCountryId: transfereeInfo.destinationCountryId,
                        departureStateId: transfereeInfo.departureStateId,
                        departureCountryId: transfereeInfo.departureCountryId,
                        oldHomePhone: transfereeInfo.oldHomePhone,
                        oldOfficePhone: transfereeInfo.oldOfficePhone,
                        altEmail: transfereeInfo.alternateEmail,
                        isVIP: transfereeInfo.vip,
                        policyId: transfereeInfo.policyId,
                        estimatedMoveDate: transfereeInfo.estimatedMoveDate,
                        isConfidentialFile: transfereeInfo.isConfidentialFile,
                      };

                      this.props.setBaseMoveInfo(payload);
                      this.props.history.push('/authorizations/new');
                    }}
                  >
                    New Move
                  </Button>
                </Box>
              </Box>
              
            </div>
            <Avatar className={classes.avatar}><AccountCircle style={{ height: '120px', width: '120px', marginLeft: isIE ? '-10px' : '0' }} /></Avatar>
          </div >
        )}
        <div className={classes.employeeInfoBar} >
          <Grid container>
            <Grid item xs={12} sm={6} lg={3}>
              <ReadOnlyText
                label="Spouse / Partner Name"
                name="spouse"
                value={(transfereeInfo.spouseFirstName && transfereeInfo.spouseLastName) ? `${transfereeInfo.spouseFirstName  } ${  transfereeInfo.spouseLastName}` : ' '}
              />
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Employee Type"
                    name="employeeType"
                    value={(transfereeInfo.moveType) ? transfereeInfo.moveType : ' '}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Move Reason"
                    name="moveReason"
                    value={(transfereeInfo.moveReason) ? transfereeInfo.moveReason : ' '}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <ReadOnlyText
                label="Origin Location"
                name="origin"
                value={(transfereeInfo.departureCity && transfereeInfo.departureState) ? `${transfereeInfo.departureCity  }, ${  transfereeInfo.departureState  }${transfereeInfo.departureCountry ? ` ${  transfereeInfo.departureCountry}` : ' '}` : ' '}
              />
              <ReadOnlyText
                label="Destination Location"
                name="destination"
                value={(transfereeInfo.destinationCity && transfereeInfo.destinationState) ? `${transfereeInfo.destinationCity  }, ${  transfereeInfo.destinationState  }${transfereeInfo.destinationCountry ? ` ${  transfereeInfo.destinationCountry}` : ' '}` : ' '}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Effective Date"
                    name="startDate"
                    value={(transfereeInfo.newJobStartDate) ? getLocaleDateString(transfereeInfo.newJobStartDate) : ' '}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Proposed End"
                    name="endDate"
                    value={(transfereeInfo.endDate) ? getLocaleDateString(ProposedEndDate) : ' '}
                  />
                </Grid> */}
              </Grid>
              <ReadOnlyText
                label="Authorized By"
                name="authBy"
                value={(transfereeInfo.addedBy) ? transfereeInfo.addedBy : ' '}
              />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Contact Number"
                    name="oldMobile"
                    value={convertPhoneNumber(transfereeInfo.primaryPhoneNumber)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ReadOnlyText
                    label="Auth Date"
                    name="authDate"
                    value={(transfereeInfo.initiationDate) ? getLocaleDateString(transfereeInfo.initiationDate) : ' '}
                  />
                </Grid>
              </Grid>
              {/* <ReadOnlyText
                label="Relocation Counselor"
                name="reloCounselor"
                value={(teamMembers && teamMembers) ? `${HomesaleRepFirst} ${HomesaleRepLast}` : ' '}
              /> */}
            </Grid> 
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={6} md={3}>
              <ReadOnlyText
                label="Policy"
                name="policy"
                value={(transfereeInfo.reloPolicy) ? transfereeInfo.reloPolicy : ' '}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <ReadOnlyText
                label="Status"
                name="status"
                value={(transfereeInfo.fileStatus) ? transfereeInfo.fileStatus : ' '}
              />
            </Grid>
            {
              transfereeInfo.division &&
                <Grid item xs={12} sm={6} md={3}>
                  <ReadOnlyText
                    label="Division"
                    name="division"
                    value={(transfereeInfo.division) ? transfereeInfo.division : ' '}
                  />
                </Grid>
            }
            {/* {
              BusinessUnit &&
                <Grid item xs={12} sm={6} md={3}>
                  <ReadOnlyText
                    label="Business Unit"
                    name="policy"
                    value={(BusinessUnit) ? BusinessUnit : ' '}
                  />
                </Grid>
            } */}
            {numFamilyMembers && 
              <Grid item xs={12} sm={6} md={3}>
                <ReadOnlyText
                  label="Family Size (Includes Transferee)"
                  name="numFamilyMembers"
                  value={(numFamilyMembers) ? numFamilyMembers : ' '}
                />
              </Grid>
            }
          </Grid>
        </div >
        <AppBar position="static">
          <Tabs
            value={activeTransfereeTab}
            onChange={this.handleTabChange}
            variant="scrollable"
            scrollButtons="on"
          >
            <Tab label="Employee Services" />
            <Tab label="Expenses" />
            <Tab label="Documents / Notes" />
            <Tab label="Timeline" />
          </Tabs>
        </AppBar>

        {activeTransfereeTab === 0 && <TabContainer><ServicesCards services={services} transfereeInfo={transfereeInfo} homesaleSummary={homesaleSummary} tempLivingSummary={tempLivingSummary} globalSummary={globalSummary} hhgSummary={hhgSummary} customFields={customFieldValues} ptCodeHistories={normalizedPTCodeHistories} isPtCodeProcessActive={isPtCodeProcessActive} clientFields={clientFields} clientDivisions={clientDivisions} clientInfo={clientInfo} /></TabContainer>}
        {activeTransfereeTab === 1 && <TabContainer><ExpensesView exceptions={exceptions} reports={reports} vendorExpenses={vendorExpenses} moveCap={transfereeInfo.moveCap} /></TabContainer>}
        {activeTransfereeTab === 2 && <TabContainer><DocumentsNotes authId={this.props.fileId ? this.props.fileId : decodeURIComponent(this.props.match.params.id)} documents={documents} comments={commentsInfo} allEnums={allEnums} busCodes={busCodes} /></TabContainer>}
        {activeTransfereeTab === 3 &&
          <TabContainer>
            <TimelineList
              data={timelineItems}
              daysLeft={daysLeft}
              totalDays={totalDays}
              showVideoModal={() => console.log('showVideoModal')}
              showInfoModal={() => console.log('showInfoModal')}
              handleMarkComplete={() => console.log('handleMarkComplete')}
            />
          </TabContainer>
        }
      </div >
    );
  }
}

SubmittedAuthDetails.propTypes = {

};

const mapStateToProps = (state) => {
  return {
    submittedAuthDetail: state.transferees.get('submittedAuthDetail'),
    submittedAuthExceptions: state.transferees.get('submittedAuthExceptions'),
    clientFields: state.transferees.get('clientFields'),
    searchComments: state.transferees.get('searchComments'),
    userInformation: state.layout.get('userInformation'),
    isLoadingAuth: state.transferees.get('isLoading'),
    // busCodes: state.transferees.get('busCodes'),
    timelineItems: state.transferees.get('timelineItems'),
    reports: state.transferees.get('reports'),
    activeTransfereeTab: state.transferees.get('activeTransfereeTab'),
    clientDivisions: state.layout.get('clientDivisions'),
    clientInfo: state.authorizations.get('clientInfo'),
    allEnums: state.transferees.get('allEnums'),
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    getSubmittedAuthorization,
    getExceptionsByAuthorizationId,
    getClientSpecificFields,
    getClientInformation,
    setPageTitle,
    getSearchCommentResults,
    getBusCodes,
    getTimelineItems,
    getReports,
    setBackButtonPath,
    setActiveTransfereeTab,
    setBaseMoveInfo,
    getSimilarTransfereeSummaries,
    getTransfereeById,
    getSimilarTransferees,
    getAllEnumerations
  }),
)(SubmittedAuthDetails);
